// extracted by mini-css-extract-plugin
module.exports = {"ControlPanel":"ControlPanel_ControlPanel__2k53x"};